import { StreamRoleId } from '@mimir/common/dto/mediaAvailability';
import type { PlayableArtifact, PlayableItemDto, PlayableItemGetOptions } from '@mimir/common/dto/playableItemDto';
import { type PlayableArtifactSelectionOptions, type SelectedPlayableArtifact, selectPlayableArtifact } from '@mimir/common/util/selectPlayableArtifact';

export function getCutterPlayableItemGetOptions(): PlayableItemGetOptions {
  return {
    useEditProxy: true,
    streamSetPreference: [
      [StreamRoleId.LiveRecordWebproxyTs],
      [StreamRoleId.LiveRecordAudioOnlyProxyTs],
      [StreamRoleId.LiveRecordAudioOnlyHighresTs],
      [StreamRoleId.LiveRecordHighresTs],
      [StreamRoleId.EditProxyFull],
    ],
    peakOffset: undefined,
  };
}

export function getCutterArtifactSelectionOptions(): PlayableArtifactSelectionOptions {
  return {
    specificQuality: null,
    autoSelectHint: 'medium',
    blacklistedQualities: [],
  };
}

/**
 * Returns the artifact the cutter would play for the item, or null if the
 * item has no artifact the cutter's segment provider can read yet.
 */
export function selectCutterPlayableArtifact(item: PlayableItemDto, options: PlayableArtifactSelectionOptions): SelectedPlayableArtifact | null {
  return selectPlayableArtifact(item.availableArtifacts.filter(playableArtifactIsSupported), options);
}

function streamRoleIdIsSupported(streamId: StreamRoleId): boolean {
  switch (streamId) {
    case StreamRoleId.EditProxyFull:
    case StreamRoleId.LiveRecordHighresTs:
    case StreamRoleId.LiveRecordWebproxyTs:
    case StreamRoleId.LiveRecordAudioOnlyHighresTs:
    case StreamRoleId.LiveRecordAudioOnlyProxyTs:
      return true;
    case StreamRoleId.PngPageProxy:
    case StreamRoleId.BrowsePreviewVideo:
    case StreamRoleId.LiveRecordThumbnail:
    // In order to use the fragmented stream variants below we need to consume
    // the video and audio from two different streams. We don't support this
    // in the MimirSegmentProvider.
    case StreamRoleId.BrowsePreviewAudioDownmix:
    case StreamRoleId.BrowsePreviewVideoAudioDownMix:
      return false;
    }
}

function playableArtifactIsSupported(playableArtifact: PlayableArtifact): boolean {
  if (playableArtifact.type === 'stream') {
    return playableArtifact.streamSet.every(streamRoleIdIsSupported);
  }
  return true;
}
